"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useLogger = void 0;
var _react = require("react");
var _loggerContext = require("./loggerContext");
/**
 * Creates a child Logger from parent logger and lets you use it
 *
 * @example
 *
 * #### Use just parent Logger
 * ```js
 * import { Logger, LoggerProvider, useLogger } from '@ori/logger';
 *
 * const appLogger = new Logger('@ori/custom');
 *
 * // Provide Logger with provider
 * const ParentComponent = () => <LoggerProvider logger={appLogger}><Component /></LoggerProvider>
 *
 * const Component = () => {
 *    // This lets you subscribe to logger in React world
 *    const myLogger = useLogger()
 *    // ...
 * }
 * ```
 *
 * #### Use child Logger from parent logger in React world
 * ```js
 * import { Logger, LoggerProvider, useLogger } from '@ori/logger';
 *
 * const appLogger = new Logger('@ori/custom');
 *
 * // Provide Logger with provider
 * const ParentComponent = () => <LoggerProvider logger={appLogger}><Component /></LoggerProvider>
 *
 * const Component = () => {
 *    // This lets you create child logger which just lives in this component
 *    const myLogger = useLogger('my part')
 *    // ...
 * }
 * ```
 */
const useLogger = (areaName, metadata) => {
  const parentLogger = (0, _react.useContext)(_loggerContext.loggerContext);
  if (!parentLogger) {
    throw new Error('No logger has been provided with LoggerProvider in react tree');
  }
  const childLogger = (0, _react.useMemo)(() => parentLogger.createChild(areaName, metadata), [parentLogger, areaName, metadata]);
  return childLogger;
};
exports.useLogger = useLogger;
